import { render } from "./ShopPosDialog.vue?vue&type=template&id=7af61ac7&scoped=true"
import script from "./ShopPosDialog.vue?vue&type=script&lang=js"
export * from "./ShopPosDialog.vue?vue&type=script&lang=js"

import "./ShopPosDialog.vue?vue&type=style&index=0&id=7af61ac7&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af61ac7"]])

export default __exports__